import { useState } from 'react'
import { CenterCategoryOneType } from '../navigator/types'
import { FailureValues } from '../types'

interface Args<T> {
  value: string | number | null | boolean | CenterCategoryOneType | FailureValues
  name: keyof T
}

export const useForm = <T extends object>(initValues: T) => {
  const [values, setValues] = useState<T>(initValues)

  const onChangeValues = ({ value, name }: Args<T>) => {
    setValues((oldValues) => ({
      ...oldValues,
      [name]: value,
    }))
  }

  const setInitialValues = (values: T) => setValues(values)

  const resetForm = () => setValues(initValues)

  return { values, onChangeValues, resetForm, setInitialValues }
}
